document.addEventListener('DOMContentLoaded', function () {
  // Nivel 1
  document.querySelectorAll('.mobile-menu .has-submenu > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.innerWidth < 769) {
        e.preventDefault();
        this.parentElement.classList.toggle('open');
      }
    });
  });

  // Nivel 2
  document.querySelectorAll('.mobile-menu .menu-subitem.has-submenu > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.innerWidth < 769) {
        e.preventDefault();
        this.parentElement.classList.toggle('open');
      }
    });
  });
});
